import React from 'react';

import classes from './ToolkitWhatsIncluded.module.scss';

const ToolkitWhatsIncluded = ({ html }) => {
    return (
        <div className={classes['card']}>
            <div className={classes['title']}>
                <h3>What you’ll get</h3>
            </div>
            <div className={classes['divider']} />
            <div
                className={classes['content']}
                dangerouslySetInnerHTML={{ __html: html || '' }}
            />
        </div>
    );
};

export default ToolkitWhatsIncluded;
